/* eslint-disable react-hooks/exhaustive-deps */
import React, { FC, ReactElement, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
//redux import
import { LoadDestinationMainNavData } from './DestinationMainNavSlice';
import { RootState } from '../../Redux/rootReducer';

import SearchField from '../../Components/SearchField';
import VacationType from '../../Components/VacationType';
import Region from '../../Components/Region';
import MoreWaystrade from '../../Components/MoreWaysTrade';

import { Region as IRegion } from '../../Components/Region/Interfaces/Region';
import { VacationType as IVacationType } from '../../Components/VacationType/Interfaces/VacationType';
import { DestinationContent } from './Interfaces/DestinationMainNav';

import { LoadingSpinner, ErrorComponent } from 'mvw-component-library';

import { ERROR_MESSAGE, INFO_ICON } from '../../Utility/constants';

import './DestinationMainNav.scss';

const DestinationMainNav: FC<any> = (props: any): ReactElement => {
  const dispatch = useDispatch();

  //Dispatching the call to fetch Destionation page data
  useEffect(() => {
    dispatch(LoadDestinationMainNavData());
  }, []);

  //Fetching the nav data from root state
  const destinationData: DestinationContent | undefined = useSelector((state: RootState) => state.destinationContent);
  const isLoading: boolean = destinationData?.isLoading ? destinationData.isLoading : false;
  const hasContentError: boolean = destinationData?.hasError ? destinationData.hasError : false;

  const regionData: IRegion[] = destinationData?.data ? destinationData.data.regions : [];
  const vacationData: IVacationType[] = destinationData?.data ? destinationData.data.vacationTypes : [];
  const searchContent = destinationData?.data?.attributes?.['vistana.header.nav.label-content.destinationNavLabels'];
  const searchIcon =
    destinationData?.data?.attributes &&
    getImageWithDomain(destinationData?.data?.attributes['vistana.header.nav.label-content.magnifyingglassicon']);
  const moreWaysContent = destinationData?.data?.attributes?.['vistana.header.nav.navigation-section-content.linkList'];
  const areaLabelText = 'Destination navigation';
  return (
    <>
      {!isLoading ? (
        hasContentError ? (
          <ErrorComponent errorMessage={ERROR_MESSAGE} infoIcon={INFO_ICON} />
        ) : (
          <div className="rc-container-fluid" aria-label={areaLabelText} role="main">
            <h1 className="hide">{areaLabelText}</h1>
            <div className="rc-row rc-justify-content-between">
              <div className="rc-col-lg-9 rc-col-md-9 rc-col-sm-12 destination-left-container">
                <SearchField SearchContent={searchContent} searchIcon={searchIcon} />
                <VacationType vacationTypesContent={vacationData} />
                <Region RegionContent={regionData} />
              </div>
              <div className="rc-col-lg-3 rc-col-md-3 rc-col-sm-12 destination-right-nav">
                <MoreWaystrade moreWaysContent={moreWaysContent}></MoreWaystrade>
              </div>
            </div>
          </div>
        )
      ) : (
        <LoadingSpinner />
      )}
    </>
  );
};

export default DestinationMainNav;
// const fetchIconFromResponse = (attributes: any, property: string, node: string) => {
//   const iconObj = attributes ? attributes[`${property}`] : '';
//   const icon = iconObj && iconObj.length > 0 ? iconObj[0]?.['photo']?.[`${node}`]?.['path'] : null;
//   return icon;
// };
const getImageWithDomain = (image: any) => {
  if (image !== undefined || image !== null || image !== 'null') {
    const JAHIA_IMAGE_DOMAIN_PATH = process.env.REACT_APP_JAHIA_IMAGE_URL;
    const imageWithDomain = image && image?.includes('https') ? image : `${JAHIA_IMAGE_DOMAIN_PATH}${image}`;
    return imageWithDomain;
  } else {
    return image;
  }
};
